<template>
  <div class>
    <section>
      <div class="divname">组织架构</div>
      <div class="dept-id"
           v-for="(item,index) in departmentData"
           :key="index"
           @click="choose(item)">
        <div class="divimg">
          <van-icon name="cluster-o"
                    size="20px" />
        </div>
        <div class="divwork">
          <p>{{item.DEPT_DESCR}}</p>

        </div>
      </div>

    </section>
  </div>
</template>
 
<script>
export default {
  props: ['departmentData'],
  methods: {
    choose(item) {
      this.$emit('chooseDept', item)
    },
  },
  // filters: {
  //   cutName(val) {
  //     return val.slice(0, 1)
  //   },
  // },
}
</script>
 
<style lang = "less" scoped>
section {
  background: #fff;
  padding: 5px 0px;
  margin-bottom: 20px;
  .divname {
    color: black;
    font-size: 16px;
    font-weight: bold;
  }
  div {
    margin: 9px;
    p {
      color: black;
    }
  }

  .dept-id {
    font-size: 15px;
    border-top: 1px solid #e5e5e5;
    display: flex;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .divright {
    flex: 1;
    line-height: 55px;
    margin: 0 10px 0 0;
    color: #55a0f8;
    text-align: right;
  }
}
section:last-child {
  border-bottom: 1px solid #e5e5e5;
}
</style>